import { useCallback } from 'react'
import { create } from 'zustand'
import { CoreEntityType } from '#/index'
import { generateUUID } from '@/utils'

interface UserInfo {
  id: string
  name: string
  email: string
  avatar: string
}

interface UserState {
  userInfo: UserInfo | null
}

interface UserActions {
  setUserInfo: (userInfo: UserInfo) => void
}

export const useUserStore = create<UserState & UserActions>()(
  (set) => ({
    userInfo: null,
    setUserInfo: (userInfo) => set({ userInfo })
  })
)

export const useUserInfoId = () => {
  const { userInfo } = useUserStore()
  return userInfo?.id || '31DJe07dLKK0ZwPoepTqzDPvQ39'
}

export const useGenerateUUIDByType = () => {
  const userId = useUserInfoId()
  // 资源字母Map
  const resourceMap = {
    [CoreEntityType.Novels]: 'A',
    [CoreEntityType.NovelSeries]: 'B',
    [CoreEntityType.NovelDetails]: 'C',
    [CoreEntityType.NovelScenes]: 'D',
    [CoreEntityType.NovelActs]: 'E',
    [CoreEntityType.NovelChapters]: 'F',
    [CoreEntityType.CodexEntries]: 'G',
    [CoreEntityType.CodexFields]: 'H',
    [CoreEntityType.CodexCategories]: 'I',
    [CoreEntityType.Prompts]: 'J',
    [CoreEntityType.ModelBanks]: 'K',
    [CoreEntityType.ModelBankLinks]: 'L',
    [CoreEntityType.PromptDefaults]: 'M',
    [CoreEntityType.PromptPersonas]: 'N',
    [CoreEntityType.PromptPresets]: 'O',
  }
  // 一级资源UUID生成器
  const generateFirstLevelUUID = useCallback((type: CoreEntityType) => {
    return generateUUID({ prefix: userId.slice(4, 6) + resourceMap[type], length: 32 })
  }, [userId])
  // 子资源UUID生成器
  const generateSubLevelUUID = useCallback((parentId: string) => {
    return generateUUID({ prefix: parentId.slice(0, 8), length: 32 })
  }, [])
  return {
    generateFirstLevelUUID,
    generateSubLevelUUID,
    userId,
  }
}

